import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from "@angular/core";

import { Patient } from "../../shared/types";

@Component({
	selector: "patient-list",
	templateUrl: "patient-list.component.html",
	styleUrls: ["patient-list.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class PatientListComponent {
	// @ts-expect-error TS2564
	@Input() patients: Patient[] | null;
	@Output() selectedPatient = new EventEmitter<Patient>();
	@Input() showTasksCompletedState = false;
}
